import React from "react";
import { FaArrowRight } from "react-icons/fa";
import school_video from "../../assets/images/Icons_and_images/schoolpartnervideo.mp4";

function ProductVideos() {
  return (
    <div className="bg-white py-5">
      <div className="container" style={{ maxWidth: 1100 }}>
        <div
          className="row g-0 align-items-stretch rounded-4 overflow-hidden"
          style={{
            border: "1px solid rgba(86,61,124,0.1)",
            boxShadow: "0 4px 32px rgba(86,61,124,0.08)",
          }}
        >
          {/* ── Text column ── */}
          <div
            className="col-12 col-lg-6 p-4 p-md-5 d-flex flex-column justify-content-center"
            style={{ background: "#faf8fd" }}
          >
            {/* Eyebrow */}
            <p
              className="mb-2"
              style={{
                fontSize: "0.7rem",
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "#563D7C",
              }}
            >
              Sarasu Provides
            </p>

            <h5
              className="mb-3"
              style={{ fontWeight: 700, color: "#1a1a2e", lineHeight: 1.35 }}
            >
              Partnering with schools for testing practice
            </h5>

            {/* Divider */}
            <div
              style={{
                width: 40,
                height: 3,
                background: "#563D7C",
                borderRadius: 2,
                marginBottom: "1.25rem",
                opacity: 0.5,
              }}
            />

            <ol
              className="ps-3 mb-3"
              style={{ fontSize: "0.875rem", color: "#444", lineHeight: 2 }}
            >
              <li>Exclusive NEET Testing Practice Progress Tracker</li>
              <li>Automated NEET Test Assessment</li>
              <li>Cloud-Based NEET Online Study Tips &amp; Solutions</li>
            </ol>

            <p
              style={{
                fontSize: "0.875rem",
                color: "#555",
                lineHeight: 1.75,
                marginBottom: "1.75rem",
              }}
            >
              SARASU NEET Testing Practice cloud-based test management platform
              app that manages your testing and evaluation process of your
              students who are Doctor aspirants.
            </p>

            <div>
              <a
                href="/SchoolPartnership"
                className="d-inline-flex align-items-center gap-2"
                style={{
                  fontSize: "0.825rem",
                  fontWeight: 700,
                  color: "#563D7C",
                  textDecoration: "none",
                  borderBottom: "2px solid rgba(86,61,124,0.25)",
                  paddingBottom: "2px",
                  transition: "border-color 0.2s",
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = "#563D7C"}
                onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(86,61,124,0.25)"}
              >
                Learn more <FaArrowRight size={11} />
              </a>
            </div>
          </div>

          {/* ── Video column ── */}
          <div
            className="col-12 col-lg-6 d-flex align-items-center justify-content-center p-4 p-md-5"
            style={{ background: "#fff" }}
          >
            <div className="w-100">
              {/* Video placeholder — swap the div for <video> once src is available */}
              <div
                className="rounded-3 w-100 d-flex flex-column align-items-center justify-content-center"
                style={{
                  aspectRatio: "16/9",
                  background: "linear-gradient(135deg, #f3f0f9, #ede8f5)",
                  border: "1px solid rgba(86,61,124,0.12)",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Play button */}
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    background: "#563D7C",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 20px rgba(86,61,124,0.35)",
                    marginBottom: "0.75rem",
                  }}
                >
                  {/* Triangle */}
                  <div
                    style={{
                      width: 0,
                      height: 0,
                      borderTop: "9px solid transparent",
                      borderBottom: "9px solid transparent",
                      borderLeft: "16px solid #fff",
                      marginLeft: 4,
                    }}
                  />
                </div>
                <p
                  style={{
                    fontSize: "0.75rem",
                    color: "#563D7C",
                    fontWeight: 600,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    margin: 0,
                  }}
                >
                  Watch Demo
                </p>

                {/* Uncomment once video src is available: */}
                <video
                  className="w-100 h-100 rounded-3"
                  style={{ objectFit: "cover", position: "absolute", inset: 0 }}
                  controls
                  loop
                >
                  <source src={school_video} type="video/mp4" />
                </video>
               
              </div>

              <p
                className="text-center mt-2 mb-0"
                style={{
                  fontSize: "0.72rem",
                  color: "#999",
                  letterSpacing: "0.04em",
                }}
              >
                Sarasu NEET Platform — Product Walkthrough
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductVideos;